import React from 'react';
import { useSelector } from 'react-redux';
import classes from './CharacterDescription.module.css';

const CharacterDescription = ({ character }) => {
  const { texts } = useSelector(state => state.translate);

  return (
    <>
      <div className={classes.imageContainer}>
        <img
          src={character.largeImage}
          alt={character.nameKey}
          className={classes.characterImage}
        />
      </div>
      <div className={classes.content}>
        <div className={classes.header}>
          <h2 className={classes.characterName}>{texts[character.nameKey] || character.nameKey}</h2>
          <span className={classes.dateRange}>
            {character.dateRangeKey ? (texts[character.dateRangeKey] || character.dateRangeKey) : character.dateRange}
          </span>
        </div>
        <div className={classes.descriptionText}>
          <p>{texts[character.descriptionKey] || character.descriptionKey}</p>
        </div>
      </div>
    </>
  );
};

export default CharacterDescription;

